/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Structure:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          i18n    => Internationalization
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
  ----------------------------------------------------------------------------------------
  Item Name: Galileo Computing VueJS Dashboard
  Author: Ian Kibet
  Author URL: http://ian.galileoc.co.ke
==========================================================================================*/

import store from "@/store/store.js"

export default [{
    url: "/dashboard",
    name: "Dashboard",
    icon: "HomeIcon",
    slug: "/dashboard"
  },
  {
    url: "/harvests",
    name: "Harvests",
    icon: "FeatherIcon",
    slug: "/harvests"
  },
  {
    url: "/factory",
    name: "Factory",
    icon: "HardDriveIcon",
    slug: "/factory"
  }, {
    url: "/trucks",
    name: "Trucks",
    icon: "TruckIcon",
    slug: "/trucks"
  }, {
    url: "/operators",
    name: "Operators",
    icon: "ToolIcon",
    slug: "/operators"
  }, {
    url: "/farms",
    name: "Farms",
    icon: "FeatherIcon",
    slug: "/farms"
  },
  {
    url: "/expenses",
    name: "Expenses",
    icon: "PercentIcon",
    slug: "/expenses"
  },
  {
    header: "Manage",
    items: [{
        url: "/system/users",
        name: "Users",
        icon: "UsersIcon",
        slug: "/system/users"
      },

    ]
  },
  {
    url: "/system/settings",
    name: "Settings",
    icon: "SettingsIcon",
    slug: "/system/settings"
  },
  // {
  //   url: "/store/report",
  //   name: "Reports",
  //   icon: "PieChartIcon",
  //   slug: "/store/report"
  // },
]